import Vue from "vue";
import axios from "axios";
import Vuex from "vuex";
import env from "@/enviorments";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tab: "plans",
    faq_tab: "general",
    promotions: null,
    plans: null,
    projects: null,
    showcase: null,
    more: true,
    page: 0,
    loading: false,
  },
  mutations: {
    mutatePlan(state, val) {
      state.tab = val;
    },
    mutateFaq(state, val) {
      state.faq_tab = val;
    },
    mutatePromotions(state, promotions) {
      state.promotions = promotions;
    },
    mutatePlans(state, plans) {
      state.plans = plans;
    },
    mutateDefaultProjects(state, defaultProjects) {
      state.projects = defaultProjects;
    },
    mutateProjects(state, projects) {
      state.projects = state.projects.concat(projects);
    },
    mutateShowcase(state, showcase) {
      state.showcase = showcase;
    },
  },
  actions: {
    setPlan({ commit }, tab) {
      commit("mutatePlan", tab);
    },
    setFaq({ commit }, tab) {
      commit("mutateFaq", tab);
    },
    async getPromotions({ commit, state }) {
      state.loading = true;
      const data = (await axios.get(env.baseUrl + "promotion")).data;
      if (data.status) commit("mutatePromotions", data.data);
      console.log(data.data);
      state.loading = false;
    },
    async getShowcase({ commit, state }) {
      state.loading = true;
      const data = (await axios.get(env.baseUrl + "showcase")).data;
      if (data.status) commit("mutateShowcase", data.data);
      console.log("[Showcase]", data.data);
      state.loading = false;
    },
    async getPlans({ commit, state }) {
      state.loading = true;
      const data = (await axios.get(env.baseUrl + "plan")).data;
      console.log("plans data ", data);

      if (data.status) commit("mutatePlans", data.data);
      state.loading = false;
    },
    async getDefaultProjects({ commit, state }) {
      state.loading = true;
      const data = (await axios.get(env.baseUrl + "project-front-view")).data;
      if (data.status) commit("mutateDefaultProjects", data.data);
      state.loading = false;
    },
    async getProjects({ commit, state }) {
      state.loading = true;
      state.page += 1;
      const data = (await axios.get(env.baseUrl + "project?page=" + state.page))
        .data;
      if (data.status) commit("mutateProjects", data.data);
      if (data.meta.current_page >= data.meta.last_page) state.more = false;
      else state.more = true;
      state.loading = false;
    },
  },
});
